<template>
    <div
        class="position-relative w-100"
        @dragenter="$emit('isDragOver', true)"
        @dragleave="$emit('isDragOver', false)"
        @drop="$emit('isDragOver', false)"
    >
        <div
            @dragenter="$emit('isDragOver', true)"
            @dragleave="$emit('isDragOver', false)"
            @drop="$emit('isDragOver', false)"
            class="w-100 h-100 bg-transparent position-absolute"
        ></div>
        <div class="d-flex flex-column align-items-center font-size-125 gap-20">
            <svg width="70" height="78" viewBox="0 0 70 78" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M65.1854 24.6873L43.9698 1.28768C43.6052 0.883675 43.1601 0.560457 42.663 0.338808C42.166 0.117159 41.6281 0.0019882 41.0839 0.000701894H13.7844C12.4886 -0.0147539 11.2025 0.225182 9.99948 0.706809C8.79646 1.18844 7.70009 1.90232 6.77299 2.80769C5.84589 3.71306 5.10621 4.79219 4.59619 5.98345C4.08618 7.17471 3.81581 8.45477 3.80054 9.75053V68.2495C3.81581 69.5452 4.08618 70.8253 4.59619 72.0165C5.10621 73.2078 5.84589 74.2869 6.77299 75.1923C7.70009 76.0977 8.79646 76.8116 9.99948 77.2932C11.2025 77.7748 12.4886 78.0147 13.7844 77.9993H56.2156C57.5113 78.0147 58.7975 77.7748 60.0005 77.2932C61.2035 76.8116 62.2999 76.0977 63.227 75.1923C64.1541 74.2869 64.8937 73.2078 65.4038 72.0165C65.9138 70.8253 66.1841 69.5452 66.1994 68.2495V27.3002C66.1969 26.3337 65.8355 25.4025 65.1854 24.6873ZM42.7998 11.7005L53.4856 23.4003H45.6858C45.2774 23.3756 44.878 23.2699 44.5109 23.0892C44.1438 22.9085 43.8164 22.6565 43.5477 22.3479C43.2791 22.0394 43.0746 21.6803 42.9462 21.2919C42.8178 20.9034 42.768 20.4932 42.7998 20.0853V11.7005ZM56.2156 70.1994H13.7844C13.5128 70.2152 13.2408 70.1773 12.984 70.0878C12.7272 69.9983 12.4905 69.8589 12.2876 69.6778C12.0847 69.4966 11.9196 69.2772 11.8017 69.0321C11.6837 68.787 11.6153 68.5211 11.6004 68.2495V9.75053C11.6153 9.47894 11.6837 9.21298 11.8017 8.96787C11.9196 8.72277 12.0847 8.50336 12.2876 8.32221C12.4905 8.14105 12.7272 8.00173 12.984 7.91221C13.2408 7.8227 13.5128 7.78476 13.7844 7.80056H35V20.0853C34.937 22.9581 36.013 25.7392 37.993 27.8215C39.9731 29.9039 42.6965 31.1184 45.5688 31.2001H58.3996V68.2495C58.3846 68.5211 58.3162 68.787 58.1983 69.0321C58.0804 69.2772 57.9152 69.4966 57.7123 69.6778C57.5094 69.8589 57.2728 69.9983 57.016 70.0878C56.7591 70.1773 56.4871 70.2152 56.2156 70.1994Z"
                    fill="#fff"
                />
                <path
                    d="M42.7999 42.8998H38.9V38.9999C38.9 37.9656 38.4891 36.9736 37.7577 36.2422C37.0264 35.5109 36.0344 35.1 35.0001 35.1C33.9658 35.1 32.9738 35.5109 32.2424 36.2422C31.511 36.9736 31.1002 37.9656 31.1002 38.9999V42.8998H27.2002C26.1659 42.8998 25.1739 43.3107 24.4426 44.0421C23.7112 44.7735 23.3003 45.7654 23.3003 46.7998C23.3003 47.8341 23.7112 48.8261 24.4426 49.5574C25.1739 50.2888 26.1659 50.6997 27.2002 50.6997H31.1002V54.5996C31.1002 55.6339 31.511 56.6259 32.2424 57.3573C32.9738 58.0887 33.9658 58.4996 35.0001 58.4996C36.0344 58.4996 37.0264 58.0887 37.7577 57.3573C38.4891 56.6259 38.9 55.6339 38.9 54.5996V50.6997H42.7999C43.8343 50.6997 44.8262 50.2888 45.5576 49.5574C46.289 48.8261 46.6999 47.8341 46.6999 46.7998C46.6999 45.7654 46.289 44.7735 45.5576 44.0421C44.8262 43.3107 43.8343 42.8998 42.7999 42.8998Z"
                    fill="#fff"
                />
            </svg>

            <div class="text-center vue-uploadbox-drop-text w-100" :class="darkText">
                {{ translate('Release to drop file here!') }}
            </div>

            <div class="d-flex gap-10 flex-wrap justify-content-center">
                <div class="btn-group d-none">
                    <button
                        type="button"
                        class="btn btn-light font-size-125 font-weight-bold text-wrap vue-uploadbox-file-button position-static d-flex align-items-center justify-content-center gap-10"
                        @click.stop.prevent="openFileUploadDialog($event)"
                        :class="{ 'rounded-bottom-0': showDropdown }"
                    >
                        <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M14.4033 8.6V5L10.8033 1H2.40327C2.1911 1 1.98762 1.08429 1.83759 1.23431C1.68756 1.38434 1.60327 1.58783 1.60327 1.8V16.2C1.60327 16.4122 1.68756 16.6157 1.83759 16.7657C1.98762 16.9157 2.1911 17 2.40327 17H7.20327M11.6033 11V16.6M8.80327 13.8H14.4033"
                                stroke="#2E2E2E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                            <path
                                d="M10.4033 1V5H14.4033"
                                stroke="#2E2E2E"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        {{ translate('Choose File') }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-light dropdown-toggle dropdown-toggle-split border-left"
                        data-bs-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        @click.stop.prevent="$emit('toggle-drop-down')"
                        :class="{ 'rounded-bottom-0': showDropdown }"
                    >
                        <i class="fa fa-chevron-down"></i>
                    </button>
                    <div
                        id="dropdownMenu"
                        :class="{ show: showDropdown }"
                        class="dropdown-menu m-0 w-100 br-4 rounded-top-0 user-select-none"
                    >
                        <div class="dropdown-item px-0">
                            <span
                                id="DeviceUploadButton"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                @click.stop.prevent="openFileUploadDialog($event)"
                                :title="translate('Upload From Device')"
                                tag="span"
                            >
                                <span class="px-75"> <i style="width: 15px" class="fa fa-folder-open"></i> </span
                                >{{ translate('From Device') }}
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="dropdown-item px-0">
                            <span
                                id="dropboxButton"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                :title="translate('Choose one or more files from Dropbox')"
                                @click.stop.prevent="$emit('open-drop-box-dialog')"
                            >
                                <span class="px-75">
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 43 40" version="1.1" width="15px">
                                        <path
                                            d="m12.5 0l-12.5 8.1 8.7 7 12.5-7.8-8.7-7.3zm-12.5 21.9l12.5 8.2 8.7-7.3-12.5-7.7-8.7 6.8zm21.2 0.9l8.8 7.3 12.4-8.1-8.6-6.9-12.6 7.7zm21.2-14.7l-12.4-8.1-8.8 7.3 12.6 7.8 8.6-7zm-21.1 16.3l-8.8 7.3-3.7-2.5v2.8l12.5 7.5 12.5-7.5v-2.8l-3.8 2.5-8.7-7.3z"
                                            fill="#007EE5"
                                        />
                                    </svg> </span
                                >{{ translate('From Dropbox') }}
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div
                            class="dropdown-item px-0"
                            @click.stop.prevent="$emit('open-g-drive-dialog')"
                            :class="{ 'opacity-65': disableGdriveButton }"
                        >
                            <span
                                id="gdriveButton"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                :title="translate('Choose one or more files from Google Drive')"
                            >
                                <span class="px-75">
                                    <svg width="15px" viewBox="0 0 87.3 78" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3l13.75-23.8h-27.5c0 1.55.4 3.1 1.2 4.5z"
                                            fill="#0066da"
                                        />
                                        <path
                                            d="m43.65 25-13.75-23.8c-1.35.8-2.5 1.9-3.3 3.3l-25.4 44a9.06 9.06 0 0 0 -1.2 4.5h27.5z"
                                            fill="#00ac47"
                                        />
                                        <path
                                            d="m73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75 7.65-13.25c.8-1.4 1.2-2.95 1.2-4.5h-27.502l5.852 11.5z"
                                            fill="#ea4335"
                                        />
                                        <path
                                            d="m43.65 25 13.75-23.8c-1.35-.8-2.9-1.2-4.5-1.2h-18.5c-1.6 0-3.15.45-4.5 1.2z"
                                            fill="#00832d"
                                        />
                                        <path
                                            d="m59.8 53h-32.3l-13.75 23.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z"
                                            fill="#2684fc"
                                        />
                                        <path
                                            d="m73.4 26.5-12.7-22c-.8-1.4-1.95-2.5-3.3-3.3l-13.75 23.8 16.15 28h27.45c0-1.55-.4-3.1-1.2-4.5z"
                                            fill="#ffba00"
                                        />
                                    </svg> </span
                                >{{ translate('From Google Drive') }}
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div
                            class="dropdown-item px-0"
                            @click.stop.prevent="$emit('open-one-drive-dialog')"
                            :class="{ 'opacity-65': disableOnedriveButton }"
                            v-if="hasClientId"
                        >
                            <span
                                id="onedriveButton"
                                class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                :title="translate('Choose one or more files from OneDrive')"
                            >
                                <span class="px-75">
                                    <svg data-v-b2efc490="" width="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 5.5 32 20.5"><g data-v-b2efc490="" id="STYLE_COLOR"><path data-v-b2efc490="" d="M12.20245,11.19292l.00031-.0011,6.71765,4.02379,4.00293-1.68451.00018.00068A6.4768,6.4768,0,0,1,25.5,13c.14764,0,.29358.0067.43878.01639a10.00075,10.00075,0,0,0-18.041-3.01381C7.932,10.00215,7.9657,10,8,10A7.96073,7.96073,0,0,1,12.20245,11.19292Z" fill="#0364b8"></path> <path data-v-b2efc490="" d="M12.20276,11.19182l-.00031.0011A7.96073,7.96073,0,0,0,8,10c-.0343,0-.06805.00215-.10223.00258A7.99676,7.99676,0,0,0,1.43732,22.57277l5.924-2.49292,2.63342-1.10819,5.86353-2.46746,3.06213-1.28859Z" fill="#0078d4"></path> <path data-v-b2efc490="" d="M25.93878,13.01639C25.79358,13.0067,25.64764,13,25.5,13a6.4768,6.4768,0,0,0-2.57648.53178l-.00018-.00068-4.00293,1.68451,1.16077.69528L23.88611,18.19l1.66009.99438,5.67633,3.40007a6.5002,6.5002,0,0,0-5.28375-9.56805Z" fill="#1490df"></path> <path data-v-b2efc490="" d="M25.5462,19.18437,23.88611,18.19l-3.80493-2.2791-1.16077-.69528L15.85828,16.5042,9.99475,18.97166,7.36133,20.07985l-5.924,2.49292A7.98889,7.98889,0,0,0,8,26H25.5a6.49837,6.49837,0,0,0,5.72253-3.41556Z" fill="#28a8ea"></path></g></svg>
                                </span>{{ translate('From OneDrive') }}
                            </span>
                        </div>
                        <div class="dropdown-divider"></div>
                        <div class="dropdown-item px-0">
                          <RouterLink :to="{ name: 'remote-url' }" v-slot="{ navigate }">
                              <span
                                  class="px-0 cursor-pointer dropdown-item d-flex text-indent-0 white-space-normal align-items-center"
                                  id="externalUrlButton"
                                  :title="translate('Enter the link of a file you want to use')"
                                  @click.stop="navigate"
                              >
                                  <span class="px-75">
                                      <i style="width: 15px" class="fa fa-link"></i>
                                  </span>
                                  {{ translate('From URL') }}
                              </span>
                          </RouterLink>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>
import TransFilter from '../../../../../qaamgo/modules/sat/components/mixins/TransFilter';

export default {
    mixins: [TransFilter],
    name: 'DragAndDropView',
    props: {
        disableGdriveButton: Boolean,
        showDropdown: Boolean,
    },
    data() {
        return {};
    },
    methods: {
        openFileUploadDialog(e) {
            this.$emit('open-file-upload-dialog', e);
        },
    },
    computed: {
        darkText() {
            if (window.pageConfig.uploaderTextColor) {
                return window.pageConfig.uploaderTextColor;
            }
        },
        hasClientId() {
            return window.sat?.onedriveConfig?.clientId;
        },
    },
};
</script>
